module.exports = __webpack_public_path__ + "img/kirloskar.b789e339.png";